export { default as CategoriaList } from './Listado';